import {AfterViewInit, Component, computed, ElementRef, inject, OnInit, signal, Signal, viewChild} from '@angular/core';
import {GroupVoucherService, GroupVoucherWrapper} from '@core/services/groupVoucher.service';
import {Router, RouterLink} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalContainerComponent} from '../../../../../../modals/modal-container/modal-container.component';
import {GroupVoucherCode} from '@core/interfaces/generated/graphql';

@Component({
  selector: 'app-header-middle-voucher-modal',
  templateUrl: './header-middle-voucher-modal.component.html',
  styleUrls: ['./header-middle-voucher-modal.component.scss'],
  imports: [ModalContainerComponent, RouterLink]
})
export class HeaderMiddleVoucherModalComponent implements OnInit, AfterViewInit {
  private voucherService = inject(GroupVoucherService);
  private router = inject(Router);
  private activeModal = inject(NgbActiveModal);

  public groupVoucher: Signal<GroupVoucherWrapper>

  voucherFailed = signal('');

  readonly inputElement = viewChild<ElementRef>('inputElement');

  voucherUrlPath = computed(() => {
    if (this.groupVoucher().groupVoucher?.redirectTo) {
      return this.groupVoucher().groupVoucher?.redirectTo;
    }
    return '/voucher/list';
  })

  ngOnInit(): void {
    this.groupVoucher = this.voucherService.groupVoucherSignal;
  }

  ngAfterViewInit() {
    this.inputElement()?.nativeElement.focus();
  }

  removeGroupVoucher() {
    this.voucherService.removeGroupVoucher();
    this.activeModal.close();
    this.router.navigateByUrl('/');
  }

  closeModal() {
    this.activeModal.close();
  }

  async submit(event: any) {
    event.preventDefault();
    this.voucherFailed.set('');
    const el = event.currentTarget as HTMLFormElement;
    const value = (el.querySelector('[name="voucher"]') as HTMLInputElement).value;

    let voucher: GroupVoucherCode | undefined = undefined;
    try {
      voucher = await this.voucherService.applyGroupVoucher(value?.trim());
    } catch (error: any) {
      this.voucherFailed.set(error.graphQLErrors?.[0].debugMessage);
    }

    if (voucher) {
      this.activeModal.close();
      this.router.navigateByUrl((voucher as any)?.redirectTo || '/voucher/list');
    }
  }

}
